import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

const plusRising = keyframes`
  0% {
    outline-width: 0;
    transform: scale(0.5, 0.5);
    opacity: 0;
  }

  40% {
    transform: scale(1, 1);
    outline-width: 6px;
    opacity: 1;
  }
 
  100% {
    transform: scale(1.5,1.5);
    outline-width: 0;
    opacity: 0;
  }
`;

const plusDot = keyframes`
  0% {
    transform: scale(1);
    outline-width: 6px;
    opacity: 0;
  }

  40% {
    transform: scale(0.8);
    outline-width: 2px;
    opacity: 1;
  }
 
  100% {
    transform: scale(1);
    outline-width: 6px;
    opacity: 1;
  }

`;

/* 좁은 페이지에서 dot이 콘텐츠를 덮지 않도록 모바일에서는 축소한다 */
const DOT_SCALE = {
  default: 1,
  sm: 0.75,
} as const;

export const Dot = styled.div<{ color: string; size?: 'sm' | 'default' }>`
  position: absolute;
  z-index: ${VIEWER_Z_INDEX.dotButton};
  width: ${({ size = 'default' }) => 21 * DOT_SCALE[size]}px;
  height: ${({ size = 'default' }) => 21 * DOT_SCALE[size]}px;
  background-color: transparent;

  &::before {
    position: relative;
    display: block;
    width: 200%;
    height: 200%;
    box-sizing: border-box;
    margin-top: -33%;
    margin-left: -33%;
    animation: ${plusRising} 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    animation-delay: 0s;
    border-radius: 50%;
    content: '';
    outline: 1px solid ${({ color }) => color};
  }

  &::after {
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: ${({ size = 'default' }) => 28 * DOT_SCALE[size]}px;
    height: ${({ size = 'default' }) => 28 * DOT_SCALE[size]}px;
    animation: ${plusDot} 1.5s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
    animation-delay: 0s;
    border-radius: 50%;
    content: '';
    outline: ${({ size = 'default' }) => 6 * DOT_SCALE[size]}px solid
      ${({ color }) => color};
  }
`;

export const DotContainer = styled.div`
  position: absolute;

  cursor: pointer;

  &.disabledLayer {
    position: static;
  }
`;
